import { MeetingRepository } from "@api/repositories/MeetingRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import Vue from 'vue';
import { ParticipantStatuses } from "@api/enums/Meetings/ParticipantStatuses";
import { DateTime } from "luxon";
import { Invite } from "@api/models/meetings/Invite";
import { Meeting } from "@api/models/meetings/Meeting";
import InviteTypes from "../enums/InviteTypes";
import { UserRepository } from "@api/repositories/UserRepository";
import vueUpdateArray from '../../../common/vueUpdateArray';

export class InvitesDataHelper {
    meetingRepository: MeetingRepository;
    userRepository: UserRepository;
    invites: Invite[] = [];
    eventId: string;
    page = 1;
    take = 100000;
    count = 0;
    type = InviteTypes.received;
    loadCanceled = false;
    userId: number;
    date: DateTime;
    isLoading = false;

    constructor(eventId: string, userId: number, repositories: RepositoryFabric) {
        this.eventId = eventId;
        this.userId = userId;
        this.meetingRepository = repositories.get(RepositoryFabric.MEETING);
        this.userRepository = repositories.get(RepositoryFabric.USER);
        this.date = DateTime.local();
    }

    setEventId(eventId: string) {
        this.eventId = eventId;
        this.page = 1;
    }

    async fetchInvites(type: string, loadCanceled: boolean) {
        this.isLoading = true;
        if (type && type !== this.type) {
            this.type = type;
            this.page = 1;
            this.invites = [];
            this.count = 0;
        }
        if (loadCanceled !== this.loadCanceled) {
            this.loadCanceled = loadCanceled;
            this.page = 1;
            this.invites = [];
            this.count = 0;
        }
        if (this.type === InviteTypes.received) {
            const statuses = ['pending', 'accepted'];
            if (loadCanceled) {
                statuses.push('declined');
            }
            const result = await this.meetingRepository.invites(this.eventId, this.take, 0, true, false, statuses, this.type);
            result.invites = await this.fetchActivities(result.invites);

            // Infinite scroll выключен (take=100000), при включении надо актуализировать блок else для обновления данных без перезагрузки всего списка
            if (this.page == 1) {
                vueUpdateArray(this.invites, result.invites);
                Vue.set(this, 'count', result.count);
            }
            else {
                Vue.set(this, 'invites', [...this.invites, ...result.invites]);
            }
        } else {
            const params = {
                where: {
                    eventId: this.eventId,
                    ownerId: this.userId
                },
                take: -1,
                order: { beginAt: 'asc' }
            }
            let result: any = await this.meetingRepository.query(params);
            result = result.map((item: any) => {
                (item as any).meetingId = item.id;
                return item;
            });
            result = await this.fetchActivities(result as any);
            Vue.set(this, 'invites', result);
            Vue.set(this, 'count', result.length);
        }
        this.isLoading = false;
    }

    async fetchActivities(invites: Invite[]) {
        let ids = invites.map(item => {
            return item.participants.map(item => item.userId)
        }).flat();

        ids = Array.from(new Set(ids));
        const statuses = await this.userRepository.activity(ids as number[], 'first') || {};
        invites.forEach(item => {
            item.participants.forEach(participant => {
                participant.setFirstEntranceStatus(!!statuses[participant.userId as number])
            })
        })
        return invites;
    }

    async changeStatus(meetingId: string, participantId: string, status: ParticipantStatuses) {
        const meeting: Meeting = await this.meetingRepository.changeStatus(participantId, status);
        // this.updateStatus(meetingId, participantId, status);
        return meeting;
    }

    updateStatus(meetingId: string, participantId: string, status: ParticipantStatuses) {
        const index = this.invites.findIndex(item => item.id == participantId);
        if (index > -1) {
            const participantIndex = this.invites[index].participants.findIndex(item => item.id == participantId);
            if (participantIndex > -1) {
                Vue.set(this.invites[index].participants[participantIndex], 'status', status);
            }
            return this.invites[index];
        }
        return null;
    }

    inviteById(id: string) {
        const index = this.invites.findIndex(item => item.id == id);
        if (index > -1) {
            const participantIndex = this.invites[index].participants.findIndex(item => item.id == id);
            if (participantIndex > -1) {
                return this.invites[index].participants[participantIndex];
            }
        }
        return null;
    }

    /**
     * Return invite object by meeting id
     */
    inviteByMeetingId(meetingId: string) {
        return this.invites.find(item => item.meetingId = meetingId)
    }

    setDateToLast() {
        const minReducer = (a: DateTime, b: DateTime) => {
            return a < b ? a : b;
        };

        const date = this.invites && this.invites.length ? this.invites
            .map(item => item.beginAt as DateTime)
            .reduce(minReducer) || DateTime.local()
            : DateTime.local();

        this.date = date;
    }

    removeMeeting(meetingId: string) {
        const index = this.invites.findIndex(item => item.meetingId == meetingId);
        if (index >= 0) {
            this.invites.splice(index, 1);
            this.count--;
        }
    }
}